import store from '@/store'
import Vue from 'vue'
import { Message } from '@qs/ui'

/** 权限指令* */
const permission = Vue.directive('permission', {
  bind(el, binding) {
    const allResource = store.getters.allResource || []
    if (!allResource.includes(binding.value)) {
      el.style.display = 'none'
    }
  },
})
/**
 * 切割数字&保留固定位数
 * @param {*} value
 */
const _isVisible = function (value, limit) {
  value = value || ''
  value = String(value)
  value = value.replace(/\D/g, '')
  if (
    limit &&
    limit !== true &&
    limit !== 'true' &&
    typeof Number(limit) === 'number' &&
    Number(limit) > 0
  ) {
    value = value.substring(0, limit)
  }
  return value
}

function limitInteger(el, binding, vnode) {
  if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
    el.addEventListener('input', () => {
      el.value = _isVisible(el.value, binding.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(_isVisible(el.value, binding.value))
    })
    el.addEventListener('keyup', () => {
      el.value = _isVisible(el.value, binding.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(_isVisible(el.value, binding.value))
    })
    el.addEventListener('blur', () => {
      el.value = _isVisible(el.value, binding.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(_isVisible(el.value, binding.value))
    })
    el.addEventListener('keydown', () => {
      // 搜狗输入法bug
      el.value = _isVisible(el.value, binding.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(_isVisible(el.value, binding.value))
    })
  } else {
    for (let i = 0; i < el.getElementsByTagName('input').length; i++) {
      const item = el.getElementsByTagName('input')[i]
      item.addEventListener('input', () => {
        item.value = _isVisible(item.value, binding.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(_isVisible(item.value, binding.value))
      })
      item.addEventListener('keyup', () => {
        item.value = _isVisible(item.value, binding.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(_isVisible(item.value, binding.value))
      })
      item.addEventListener('blur', () => {
        item.value = _isVisible(item.value, binding.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(_isVisible(item.value, binding.value))
      })
    }
  }
}

function updateLimit(el, binding, vnode) {
  if (vnode.child) {
    const currentValue = _isVisible(vnode.data.model?.value || '') || ''
    vnode.child.currentValue = currentValue
    vnode.data.model && vnode.data.model.callback(currentValue)
  }
}

/**
 * 只能输入数字指令
 * @type {DirectiveOptions}
 */
const interage = Vue.directive('interage', {
  bind: limitInteger,
  update: updateLimit,
})

/**
 * @author {LDM}
 * @param {自定义指令名称} directiveName
 * @param {处理函数} funcName
 */
function getDirective(directiveName, funcName) {
  const selfDirective = Vue.directive(directiveName, {
    bind(el, binding, vnode) {
      el.addEventListener('compositionstart', onCompositionStart)
      el.addEventListener('compositionend', onCompositionEnd)
      if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
        el.addEventListener('keyup', (e) => {
          if (e.target.composing) return
          el.value = funcName(el.value, binding)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(funcName(el.value, binding))
        })
        el.addEventListener('blur', (e) => {
          if (e.target.composing) return
          el.value = funcName(el.value, binding)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(funcName(el.value, binding))
        })
      } else {
        const item = vnode.child.$refs.input
        if (!item) return
        item.addEventListener('keyup', (e) => {
          if (e.target.composing) return
          item.value = funcName(item.value, binding)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(funcName(item.value, binding))
        })
        item.addEventListener('blur', (e) => {
          if (e.target.composing) return
          item.value = funcName(item.value, binding)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(funcName(item.value, binding))
        })
      }
    },
    update(el, binding, vnode) {
      if (vnode.child) {
        const currentValue = funcName(vnode.data.model?.value || '', binding)
        vnode.child.currentValue = currentValue
        vnode.data.model.callback(currentValue)
      }
    },
  })
  return selfDirective
}
// 赋值变量 composing用于判断是否在拼写当中
function onCompositionStart(e) {
  e.target.composing = true
}

function onCompositionEnd(e) {
  if (!e.target.composing) return
  e.target.composing = false
}
/**
 * 输入小写变大写处理
 * @param {*} value
 */
const _toUpperCase = function (value) {
  value = value || ''
  if (value !== null && value !== undefined) {
    value = String(value)
    value = value.toUpperCase()
  }
  return value
}

/** 字母转大写 */
const uppercase = getDirective('uppercase', _toUpperCase)

/*
    输入空格处理成空字符串
*/

const clearVal = function (value) {
  value = value || ''
  value = String(value)
  value = value.replace(/\s/g, '')
  return value
}

const space = Vue.directive('space', {
  bind(el, binding, vnode) {
    if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
      el.addEventListener('keyup', () => {
        el.value = clearVal(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(clearVal(el.value))
      })
      el.addEventListener('blur', () => {
        el.value = clearVal(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(clearVal(el.value))
      })
      el.addEventListener('keydown', () => {
        // 搜狗输入法bug
        el.value = clearVal(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(clearVal(el.value))
      })
    } else {
      for (let i = 0; i < el.getElementsByTagName('input').length; i++) {
        const item = el.getElementsByTagName('input')[i]
        item.addEventListener('change', () => {
          item.value = clearVal(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(item.value)
        })
      }
    }
  },
})

/*
    去掉表情
*/
const emoji = function (value) {
  value = value || ''
  value = String(value)

  value = value.replace(
    // eslint-disable-next-line no-misleading-character-class
    /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\u3030/gi,
    '',
  )
  return value
}

const deleteEmoji = Vue.directive('deleteEmoji', {
  bind(el, binding, vnode) {
    if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
      el.addEventListener('input', () => {
        el.value = emoji(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(emoji(el.value))
      })
      el.addEventListener('keyup', () => {
        el.value = emoji(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(emoji(el.value))
      })
      el.addEventListener('blur', () => {
        el.value = emoji(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(emoji(el.value))
      })
      el.addEventListener('keydown', () => {
        // 搜狗输入法bug
        el.value = emoji(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(emoji(el.value))
      })
    } else {
      for (let i = 0; i < el.getElementsByTagName('input').length; i++) {
        const item = el.getElementsByTagName('input')[i]
        item.addEventListener('input', () => {
          item.value = emoji(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(emoji(item.value))
        })
        item.addEventListener('keyup', () => {
          item.value = emoji(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(emoji(item.value))
        })
        item.addEventListener('blur', () => {
          item.value = emoji(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(emoji(item.value))
        })
      }
      for (let i = 0; i < el.getElementsByTagName('textarea').length; i++) {
        const item = el.getElementsByTagName('textarea')[i]
        item.addEventListener('input', () => {
          item.value = emoji(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(emoji(item.value))
        })
        item.addEventListener('keyup', () => {
          item.value = emoji(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(emoji(item.value))
        })
        item.addEventListener('blur', () => {
          item.value = emoji(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(emoji(item.value))
        })
      }
    }
  },
})

/*
    输入纯汉字
*/

const limit_num = function (value) {
  value = value || ''
  value = String(value)
  value = value.replace(/[^\u4e00-\u9fa5]/g, '')
  return value
}

const decimal = Vue.directive('decimal', {
  bind(el, binding, vnode) {
    if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
      el.addEventListener('keyup', () => {
        el.value = limit_num(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(limit_num(el.value))
      })
      el.addEventListener('blur', () => {
        el.value = limit_num(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(limit_num(el.value))
      })
      el.addEventListener('keydown', () => {
        // 搜狗输入法bug
        el.value = limit_num(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(limit_num(el.value))
      })
    } else {
      for (let i = 0; i < el.getElementsByTagName('input').length; i++) {
        const item = el.getElementsByTagName('input')[i]
        item.addEventListener('keyup', () => {
          item.value = limit_num(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(limit_num(item.value))
        })
        item.addEventListener('blur', () => {
          item.value = limit_num(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(limit_num(item.value))
        })
      }
    }
  },
})

/*
    输入数字和字母
*/

const getAlphanumeric = function (value) {
  value = value || ''
  value = String(value)
  value = value.replace(/\W/g, '')
  return value
}

const alphanumeric = Vue.directive('alphanumeric', {
  bind(el, binding, vnode) {
    if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
      el.addEventListener('keyup', () => {
        el.value = getAlphanumeric(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(getAlphanumeric(el.value))
      })
      el.addEventListener('blur', () => {
        el.value = getAlphanumeric(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(getAlphanumeric(el.value))
      })
      el.addEventListener('keydown', () => {
        // 搜狗输入法bug
        el.value = getAlphanumeric(el.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(getAlphanumeric(el.value))
      })
    } else {
      for (let i = 0; i < el.getElementsByTagName('input').length; i++) {
        const item = el.getElementsByTagName('input')[i]
        item.addEventListener('keyup', () => {
          item.value = getAlphanumeric(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(getAlphanumeric(item.value))
        })
        item.addEventListener('blur', () => {
          item.value = getAlphanumeric(item.value)
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(getAlphanumeric(item.value))
        })
      }
    }
  },
})

// 只允许输入数字和字母
const getLimitAlphanumeric = function (value) {
  value = value || ''
  value = String(value)
  value = value.replace(/[^a-zA-Z0-9]/g, '')
  return value
}

const limitAlphanumeric = getDirective('limitAlphanumeric', getLimitAlphanumeric)


/**
 * 金额限制指令 10位整数 或者 10位+两位小数最多13位
 */

// 金额自定义指令公共函数
const limitMoneyCom = function (el, binding, vnode) {
  if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
    el.addEventListener('keyup', () => {
      if (!limitMoneyFn(el.value)) {
        const _value = getMoneyValue(el.value)
        el.value = _value
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(_value)
      }
    })
    el.addEventListener('keydown', () => {
      if (!limitMoneyFn(el.value)) {
        const _value = getMoneyValue(el.value)
        el.value = _value
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(_value)
      }
    })
    el.addEventListener('blur', () => {
      if (limitMoneyFn(el.value, 2)) {
        const _value = el.value.substr(0, el.value.length - 1)
        el.value = _value
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(_value)
      }
      const _value = thousandSeparatorReplace(el.value)
      el.value = _value
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(_value)
    })
  } else {
    const aInput = el.getElementsByTagName('input')
    for (let i = 0; i < aInput.length; i++) {
      const item = aInput[i]
      item.addEventListener('keyup', () => {
        if (!limitMoneyFn(item.value)) {
          const _value = getMoneyValue(item.value)
          item.value = _value
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(_value)
        }
      })
      item.addEventListener('keydown', () => {
        if (!limitMoneyFn(item.value)) {
          const _value = getMoneyValue(item.value)
          item.value = _value
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(_value)
        }
      })
      item.addEventListener('blur', () => {
        // 检查输入值是否为全零
        if (/^0+$/.test(item.value)) {
          item.value = '0.00'
          if (vnode && vnode.data && vnode.data.model && vnode.data.model.callback) {
            vnode.data.model.callback('0.00')
          }
        } else {
          if (limitMoneyFn(item.value, 2)) {
            const _value = item.value.substr(0, item.value.length - 1)
            item.value = _value
            vnode &&
              vnode.data &&
              vnode.data.model &&
              vnode.data.model.callback &&
              vnode.data.model.callback(_value)
          }
          const _value = thousandSeparatorReplace(item.value)
          item.value = _value
          vnode &&
            vnode.data &&
            vnode.data.model &&
            vnode.data.model.callback &&
            vnode.data.model.callback(_value)
        }
      })
    }
  }
}

const limitMoney = Vue.directive('limit-money', {
  bind: limitMoneyCom,
  update: limitMoneyCom,
})
// 千分符号替换
const thousandSeparatorReplace = (value) => {
  if (!value) return ''
  const result = value.toString().replaceAll(',', '')
  return getMoneyValue(result)
}

/**
 * 金钱正则限制 10位整数 或者 10位+两位小数最多13位
 * @param {*} val input值
 * @param {*} type 默认1， 2时为了blur时消除金额为1.小数点后不输入情况，去除.
 * @returns boolean
 */
const limitMoneyFn = (val, type = 1) => {
  val = String(val)
  let reg = null
  if (type === 1) {
    reg = /^[0-9]{1,10}(\.[0-9]{0,2})?$/
  }
  if (type === 2) {
    reg = /^[1-9]{1,10}\.$/
  }
  return reg.test(val)
}

// 递归调用事件，获取金额符合规则的值
const getMoneyValue = function getval(val) {
  if (limitMoneyFn(val) || val === '') {
    return val
  } else {
    return getval(val.substr(0, val.length - 1))
  }
}

/**
 * 附件下载指令
 */
const download = Vue.directive('down', {
  inserted: (el, binding) => {
    // 传过来的Name,没有默认没有带.pdf这种自动截取路径的后缀拼接
    const { url } = binding.value
    let fileName = binding.value.name
    el.style.cssText = `cursor: pointer;${el.style.cssText}`
    // 如果没有带.后缀，自动适配新的
    if (fileName.indexOf('.') === -1) {
      let suffix = ''
      try {
        const { pathname } = new URL(url)
        suffix = pathname.slice(pathname.lastIndexOf('.'))
      } catch (e) {
        suffix = url.slice(url.lastIndexOf('.'))
      }
      fileName += suffix
    }
    // el.innerHTML = fileName
    el.addEventListener('click', () => {
      const link = document.createElement('a')
      // 将链接地址字符内容转变成blob地址
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          link.href = URL.createObjectURL(blob)
          console.log(link.href)
          link.download = fileName
          document.body.appendChild(link)
          link.click()
        })
    })
  },
})

/**
 * 千分符
 */
const _thousandSeparatorCom = function (el, binding, vnode) {
  const nullTxt = vnode.data.attrs && vnode.data.attrs.nullTxt

  const x = binding.value

  el.innerText = ''
  // 如果传入的值为空，则判断是否有空值占位符传入，如果有则显示空占位符

  if (!x || isNaN(Number(x))) {
    el.innerText = nullTxt || '0.00'
    return
  }

  // 保留两位补 0
  let value = x
  if (typeof value === 'string' && value.indexOf('元') >= 0) { value = value.replace('元', '') }
  value = Math.round(parseFloat(x) * 100) / 100
  const s = value.toString().split('.')
  if (s.length === 1) {
    value = `${value.toString()}.00`
  }
  if (s.length > 1) {
    if (s[1].length < 2) {
      value = `${value.toString()}0`
    }
  }
  // 千分位
  el.innerText = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const thousandSeparator = Vue.directive('thousand-separator', {
  update: _thousandSeparatorCom,
  inserted: _thousandSeparatorCom,
})
const _clearSpace = function (el, binding, vnode) {
  if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
    el.addEventListener('input', () => {
      el.value = clearVal(el.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(clearVal(el.value))
    })
    el.addEventListener('keyup', () => {
      el.value = clearVal(el.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(clearVal(el.value))
    })
    el.addEventListener('blur', () => {
      el.value = clearVal(el.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(clearVal(el.value))
    })
    el.addEventListener('keydown', () => {
      // 搜狗输入法bug
      el.value = clearVal(el.value)
      vnode &&
        vnode.data &&
        vnode.data.model &&
        vnode.data.model.callback &&
        vnode.data.model.callback(clearVal(el.value))
    })
  } else {
    for (let i = 0; i < el.getElementsByTagName('input').length; i++) {
      const item = el.getElementsByTagName('input')[i]
      item.addEventListener('change', () => {
        // 搜狗输入法bug
        item.value = clearVal(item.value)
        vnode &&
          vnode.data &&
          vnode.data.model &&
          vnode.data.model.callback &&
          vnode.data.model.callback(clearVal(item.value))
      })
    }
  }
}
const unspace = Vue.directive('unspace', {
  bind: _clearSpace,
  update: _clearSpace,
})
/**
 * select 已选元素不可删除
 */
const noRemovableDefaultSelect = Vue.directive('noRemovableDefaultSelect', {
  bind(el, bindings) {
    settingFun(el, bindings)
  },
  componentUpdated(el, bindings) {
    settingFun(el, bindings)
  },
})

function settingFun(el, bindings) {
  const [defaultValues] = bindings.value
  const dealStyle = function (tags) {
    // eslint-disable-next-line no-shadow
    tags.forEach((el) => {
      if (defaultValues.includes(el.childNodes[0].innerText)) {
        el.childNodes[1].style.display = 'none' // close 图标隐藏掉
      }
    })
  }
  // 设置样式隐藏close icon
  const tags = el.querySelectorAll('.el-tag--closable')
  if (tags.length === 0) {
    // 初始化tags为空处理
    setTimeout(() => {
      const tagTemp = el.querySelectorAll('.el-tag--closable')
      dealStyle(tagTemp)
    })
  } else {
    dealStyle(tags)
  }
}

/**
 * 整数或者两位小数
 */
const integerOrTwoDecimal = Vue.directive('integerOrTwoDecimal', {
  bind(el) {
    el.addEventListener('compositionstart', (e) => {
      e.target.composing = true
    })

    el.addEventListener('compositionend', (e) => {
      e.target.composing = false
      handleInput(e)
    })

    el.addEventListener('input', (e) => {
      if (!e.target.composing) {
        handleInput(e)
      }
    })

    function handleInput(e) {
      let { value } = e.target
      // 去除首位空格
      value = value.trim()
      // 去除非数字和小数点的字符
      value = value.replace(/[^\d.]/g, '')
      // 如果有小数点，保留两位小数
      if (value.includes('.')) {
        const parts = value.split('.')
        // 限制小数位数为两位
        value = `${parts[0]}.${parts[1].slice(0, 2)}`
      }
      // 不允许以0开头的多位数字
      if (
        value.length > 1 &&
        value.startsWith('0') &&
        !value.startsWith('0.')
      ) {
        value = value.slice(1)
      }
      // 不允许输入无效的小数
      if (value.startsWith('.')) {
        value = ''
      }
      // 更新输入框的值
      e.target.value = value
    }
  },
})

const integerNumber = Vue.directive('integerNumber', {
  bind(el, binding) {
    // 设置指令的参数，默认值为0和Infinity
    const min = binding.value?.min ?? -Infinity
    const max = binding.value?.max ?? Infinity

    // 处理输入值的核心函数
    const processValue = (value) => {
      // 移除所有非数字字符
      value = value.replace(/[^0-9]/g, '')

      // 如果为空则返回空字符串
      if (!value) return ''

      // 转为数字后判断范围
      const numValue = Number(value)

      if (numValue < min) {
        return min.toString()
      }
      if (numValue > max) {
        return max.toString()
      }

      return value
    }

    // 创建事件监听器函数
    const inputHandler = (e) => {
      const oldValue = e.target.value
      let newValue = processValue(oldValue)
      // 如果数字以0开头，则将0去除，确保不出现类似06这样的数字,但000这样的数字保留
      newValue = newValue.replace(/^0(?!0)(\d+)$/, '$1')
      // 只在值真正改变时更新
      if (oldValue !== newValue) {
        e.target.value = newValue
        // 触发 input 事件以确保 v-model 更新
        e.target.dispatchEvent(new Event('input'))
      }
    }

    // 处理粘贴事件
    const pasteHandler = (e) => {
      e.preventDefault()
      // 获取粘贴的文本
      const pastedText = (e.clipboardData || window.clipboardData).getData('text')
      const newValue = processValue(pastedText)

      // 使用 document.execCommand 插入处理后的文本
      document.execCommand('insertText', false, newValue)
    }

    // 处理键盘按下事件，预防非法输入
    const keydownHandler = (e) => {
      // 允许的按键：数字、方向键、删除键、退格键等
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
        'Home', 'End', 'Tab',
      ]

      // 如果是功能键，则允许
      if (e.ctrlKey || e.metaKey) return

      // 如果不是数字键且不在允许的按键列表中，阻止输入
      if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault()
      }
    }

    let isComposing = false

    // 输入法开始
    const compositionStartHandler = () => {
      isComposing = true
    }

    // 输入法结束
    const compositionEndHandler = (e) => {
      isComposing = false
      // 立即处理当前值
      inputHandler(e)
    }

    // 输入事件处理
    const inputEventHandler = (e) => {
      // 在输入法结束后才处理输入
      if (!isComposing) {
        inputHandler(e)
      }
    }

    // 将事件处理函数存储在元素上
    el._handlers = {
      input: inputEventHandler,
      compositionStart: compositionStartHandler,
      compositionEnd: compositionEndHandler,
      paste: pasteHandler,
      keydown: keydownHandler,
    }

    // 添加所有事件监听器
    el.addEventListener('input', el._handlers.input)
    el.addEventListener('compositionstart', el._handlers.compositionStart)
    el.addEventListener('compositionend', el._handlers.compositionEnd)
    el.addEventListener('paste', el._handlers.paste)
    el.addEventListener('keydown', el._handlers.keydown)
  },

  unbind(el) {
    // 移除所有事件监听器
    if (el._handlers) {
      el.removeEventListener('input', el._handlers.input)
      el.removeEventListener('compositionstart', el._handlers.compositionStart)
      el.removeEventListener('compositionend', el._handlers.compositionEnd)
      el.removeEventListener('paste', el._handlers.paste)
      el.removeEventListener('keydown', el._handlers.keydown)
      delete el._handlers
    }
  },
})


export {
  _isVisible,
  alphanumeric,
  limitAlphanumeric,
  clearVal,
  decimal,
  deleteEmoji,
  download,
  emoji,
  getMoneyValue,
  integerOrTwoDecimal,
  interage,
  limitMoney,
  noRemovableDefaultSelect,
  permission,
  space,
  thousandSeparator,
  thousandSeparatorReplace,
  unspace,
  uppercase,
  integerNumber,
}
